import { defineComponent as _defineComponent } from 'vue';
import { Teleport } from 'vue';
import { useSpinner } from '../Plugins/spinner';
import GridLoader from 'vue-spinner/src/GridLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SpinnerFullscreen',
    setup(__props, { expose }) {
        expose();
        const spinner = useSpinner();
        const visible = spinner.isVisible.value;
        const __returned__ = { spinner, visible, Teleport, GridLoader };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
